import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Páginas públicas
import HomePage from './pages/Home/HomePage';
import AboutPage from './pages/About/AboutPage';
import ContactPage from './pages/Contact/ContactPage';
import LoginPage from './pages/Login/LoginPage';

// Componentes de la app
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AppLayout from './components/AppLayout/AppLayout';
import AppLoader from './pages/AppLoader/AppLoader';

// Dashboards por rol
import ColaboradorDashboard from './pages/ColaboradorDashboard/ColaboradorDashboard';
import PagosColaborador from './pages/ColaboradorDashboard/PagosColaborador';
import ColaboradorInvitaciones from './pages/ColaboradorDashboard/ColaboradorInvitaciones';
import JefeInvitaciones from './pages/JefeDashboard/JefeInvitaciones';
import JefeTareas from './pages/JefeDashboard/JefeTareas';
import JefeProyectoDetalle from './pages/JefeDashboard/JefeProyectoDetalle';
import JefeProyectos from './pages/JefeDashboard/JefeProyectos';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import AdminSuscripcion from './pages/AdminDashboard/AdminSuscripcion';
import JefeDashboard from './pages/JefeDashboard/JefeDashboard';
import ColaboradorProyectoDetalle from './pages/ColaboradorDashboard/ColaboradorProyectoDetalle';

// Módulos de Admin
import GestionUsuarios from './pages/GestionUsuarios/GestionUsuarios';
import GestionProyectos from './pages/GestionProyectos/GestionProyectos';
import Configuracion from './pages/Configuracion/Configuracion';
import ReportesPago from './pages/ReportesPago/ReportesPago';
import ReportesProyectos from './pages/ReportesProyectos/ReportesProyectos';
import Perfil from './pages/Perfil/Perfil';
import CompleteInvite from './pages/Auth/CompleteInvite';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import SuperAdminDashboard from './pages/superAdminDashboard/SuperAdminDashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<HomePage />} />
        <Route path="/quienes-somos" element={<AboutPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/complete-invite" element={<CompleteInvite />} />

        {/* Rutas protegidas */}
        <Route element={<ProtectedRoute />}>
          {/* Ruta del loader que determina el rol */}
          <Route path="/app-loader" element={<AppLoader />} />

          {/* Layout principal de la app con rutas anidadas por rol */}
          <Route path="/app" element={<AppLayout />}>
            {/* Rutas del Colaborador */}
            <Route path="colaborador/dashboard" element={<ColaboradorDashboard />} />
            <Route path="colaborador/pagos" element={<PagosColaborador />} />
            <Route path="colaborador/invitaciones" element={<ColaboradorInvitaciones />} />
            <Route path="colaborador/proyectos" element={<ColaboradorInvitaciones />} />
            <Route path="colaborador/proyectos/:id" element={<ColaboradorProyectoDetalle />} />

            {/* Rutas del Jefe */}
            <Route path="jefe/inicio" element={<JefeDashboard />} />
            <Route path="jefe/invitaciones" element={<JefeInvitaciones />} />
            <Route path="jefe/proyectos" element={<JefeProyectos />} />
            <Route path="jefe/tareas" element={<JefeTareas />} />
            <Route path="jefe/proyectos/:id" element={<JefeProyectoDetalle />} />

            {/* Rutas del Admin */}
            <Route path="admin/dashboard" element={<AdminDashboard />} />
            <Route path="admin/suscripcion" element={<AdminSuscripcion />} />
            <Route path="admin/usuarios" element={<GestionUsuarios />} />
            <Route path="admin/proyectos" element={<GestionProyectos />} />
            <Route path="admin/configuracion" element={<Configuracion />} />
            <Route path="admin/reportes" element={<ReportesPago />} />
            <Route path="admin/reportes-proyectos" element={<ReportesProyectos />} />

            {/* Ruta del SuperAdmin */}
            <Route path="superadmin/dashboard" element={<SuperAdminDashboard />} />

            {/* Perfil (visible para cualquier rol) */}
            <Route path="perfil" element={<Perfil />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
